import News from './News.jsx';

export {
  News
}


// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/news/index.js